<template>
    <div>
        <div class="mt-5 text-center p-20 border border-secondary rounded">
			<div class=" h-100  align-middle" @drop.prevent="addFile" @dragover.prevent style="min-height:300px">
				<div style="color:#ccc">
					<img src="@/assets/img/UploadLogo.png" />
					<br>
					<br>
					<span>Drop Files Here</span>
					<br>
					<span>Or</span>
					<br>
					<br>
					<input type="file" class="btn btn-secondary w-50" @change="addFile" placeholder="Select Files" multiple>
				</div>
				
			</div>
		</div>
		<template v-if="url.length > 0"> 
			<h4 class="mt-4">Foto Yang Akan Diunggah</h4>
			<hr>
			<div class="row" >
				<div class="col-md-2 text-center" v-for="(pic , index) in url">
					<!-- {{pic}} -->
					<img :src="pic" style="width:100%;max-height:200px"/>
					<button class="mt-2 btn btn-danger" @click="deleteFile(index)">Delete</button>

				</div>
			</div>
		</template>
    </div>
</template>

<script>
import env from '@/env'
export default {
    data () {
        return {
            url : [],
            file : [],
            loading : false
        }
    },
    props : ['form_code'],
    methods : {
        addFile(data) {
			this.file = Array.from(data.dataTransfer ? data.dataTransfer.files : data.target.files);
			// console.log(file)
            
            for(var i = 0 ; i < this.file.length ; i ++) {
				// var size  = file[i].size / 1024 / 1024;
				// this.$emit('uploadDocument' , file[i], size)
				let blobURL = URL.createObjectURL(this.file[i])

				this.url.push(blobURL)
            }

            this.$emit('updateImage' , this.file)
		},
        deleteFile(index) {
            this.file.splice(index , 1)
            this.url.splice(index , 1)
            this.$emit('updateImage' , this.file)
        }
        
        // updateWorkOrder : async function () {
		// 	let data = {
		// 		condition : {}
		// 	}

		// 	let image = await this.uploadAllImage()
		// 	console.log(image)

		// 	data.condition.imageList = this.imageList.concat(image)
		// 	// console.log(data.condition.imageList)
		// 	let vm = this
		// 	this.$http.patch('/api/v1/workorder/' + vm.form_code , {data : data})
		// 	.then((resp) => {
		// 		this.$store.dispatch('triggerAlert' , [true , 'Upload Gambar Selesai'])

		// 		this.$router.push({
		// 			name: 'WorkOrderDetailV2',
		// 			params: { type: "wo" },
		// 			query: { wo: vm.form_code.replace(/"/g, "") }
		// 		});

		// 	})
		// 	.catch((err) => {
		// 		console.log(err)
		// 	})
		// }
    }
}
</script>